import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index19() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="mb-2" />{/* End .mb-2 */}
  <div className="container">
    <div className="row">
      <div className="col-xl-3 d-none d-xl-block">
        <nav className="side-nav">
          <div className="sidenav-title">Browse Categories</div>{/* End .sidenav-title */}
          <ul className="menu-vertical sf-arrows">
            <li>
              <a href="product.html" className="sf-with-ul">Playstation</a>
              <div className="megamenu megamenu-sm">
                <div className="row no-gutters">
                  <div className="col-md-6">
                    <div className="menu-col">
                      <div className="menu-title">Games Software</div>{/* End .menu-title */}
                      <ul>
                        <li><a href="#">Action</a></li>
                        <li><a href="#">Adventure</a></li>
                        <li><a href="#">Sports</a></li>
                        <li><a href="#">Strategy</a></li>
                        <li><a href="#">Role-Playing Game</a></li>
                        <li><a href="#">Action-Adventure</a></li>
                        <li><a href="#">Stealth</a></li>
                        <li><a href="#">Shooter</a></li>
                      </ul>
                    </div>{/* End .menu-col */}
                  </div>{/* End .col-md-6 */}
                  <div className="col-md-6">
                    <div className="banner banner-overlay">
                      <a href="category.html">
                        <img src="asset/images/demos/demo-19/menu/banner-2.jpg" alt="Banner" />
                      </a>
                    </div>{/* End .banner */}
                  </div>{/* End .col-md-6 */}
                </div>{/* End .row */}
              </div>{/* End .megamenu megamenu-sm */}
            </li>
            <li className="megamenu-container">
              <a href="category.html" className="sf-with-ul">XBOX</a>
              <div className="megamenu">
                <div className="row no-gutters">
                  <div className="col-md-8">
                    <div className="menu-col">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="menu-title">Games Software</div>{/* End .menu-title */}
                          <ul>
                            <li><a href="#">Action</a></li>
                            <li><a href="#">Adventure</a></li>
                            <li><a href="#">Music</a></li>
                            <li><a href="#">Racing</a></li>
                            <li><a href="#">Sports</a></li>
                            <li><a href="#">Strategy</a></li>
                            <li><a href="#">Role-Playing Game</a></li>
                            <li><a href="#">Action-Adventure</a></li>
                            <li><a href="#">Stealth</a></li>
                            <li><a href="#">Shooter</a></li>
                            <li><a href="#">Horror</a></li>
                          </ul>
                        </div>{/* End .col-md-6 */}
                        <div className="col-md-6">
                          <div className="menu-title">Game Console &amp; Accessories</div>{/* End .menu-title */}
                          <ul>
                            <li><a href="#">Console</a></li>
                            <li><a href="#">Headsets</a></li>
                            <li><a href="#">Collectibles</a></li>
                            <li><a href="#">Gaming Chairs</a></li>
                            <li><a href="#">Controller</a></li>
                            <li><a href="#">Digital</a></li>
                          </ul>
                        </div>{/* End .col-md-6 */}
                      </div>{/* End .row */}
                    </div>{/* End .menu-col */}
                  </div>{/* End .col-md-8 */}
                  <div className="col-md-4">
                    <div className="banner banner-overlay">
                      <a href="category.html" className="banner banner-menu">
                        <img src="asset/images/demos/demo-19/menu/banner-1.jpg" alt="Banner" />
                      </a>
                    </div>{/* End .banner banner-overlay */}
                  </div>{/* End .col-md-4 */}
                </div>{/* End .row */}
              </div>{/* End .megamenu */}
            </li>
            <li><a href="#">Nindendo</a></li>
            <li><a href="#">PC Gaming</a></li>
            <li><a href="#">Phones &amp; Tablets</a></li>
            <li><a href="#">Pre-owned</a></li>
            <li><a href="#">Deals</a></li>
            <li><a href="#">Coming Soon</a></li>
            <li><a href="#">Accessories</a></li>
          </ul>{/* End .menu */}
        </nav>{/* End .side-nav */}
      </div>{/* End .col-lg-3 */}
      <div className="col-lg-8 col-xl-6">
        <div className="banner banner-overlay banner-lg  content-left">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-1.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-subtitle">Pre-order now</h4>
            <img src="asset/images/demos/demo-19/banners/banner-1-title.png" alt="Banner 1 Title" width={217} height={54} className="mb-1" />
            <a href="#" className="banner-link size-lg">Pre-Order Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-lg-6 */}
      <div className="col-sm-6 col-lg-4 col-xl-3">
        <div className="banner banner-overlay banner-sm content-right">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-2.jpg" alt="Banner" />
          </a>
          <div className="banner-content text-right">
            <h4 className="banner-subtitle">Weekend Offer</h4>
            <img className="banner-title-img" src="asset/images/demos/demo-19/banners/banner-2-title.png" alt="Banner-2" />
            <h4 className="banner-price">Save<span className="price">$19,99</span></h4>
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
        <div className="banner banner-overlay d-none d-lg-block banner-sm content-right align-center">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-3.jpg" alt="Banner" />
          </a>
          <div className="banner-content text-right">
            <img className="banner-title-img" src="asset/images/demos/demo-19/banners/banner-3-title.png" alt="Banner-3" />
            <h5 className="text-white">35% OFF</h5>
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div> 
        </div>{/* End .banner */}
      </div>{/* End .col-lg-3 */}
      <div className="col-sm-6 col-lg-3">
        <div className="banner banner-overlay banner-sm content-right align-center">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-4.jpg" alt="Banner" />
          </a>
          <div className="banner-content" style={{left: 'auto', right: '3rem', alignItems: 'flex-start'}}>
            <h4 className="banner-subtitle">Weekend Sale</h4>
            <img className="banner-title-img" src="asset/images/demos/demo-19/banners/banner-4-title.png" alt="Banner-4" />
            <h4 className="banner-price"><span className="off">25% off</span></h4>
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-lg-3 */}
      <div className="col-lg-9">
        <div className="banner banner-overlay banner-lg">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-5.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-subtitle">Amazing Value</h4>
            <img className="banner-title-img mb-1" src="asset/images/demos/demo-19/banners/banner-5-title.png" alt="Banner-5" />
            <a href="#" className="banner-link">Pre-Order Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-lg-9 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="icon-boxes-container icon-boxes-separator bg-transparent">
    <div className="container">
      <div className="row">
        <div className="col-sm-6 col-lg-3">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-rocket" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Free Shipping</h3>{/* End .icon-box-title */}
              <p>Orders $50 or more</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
        </div>{/* End .col-sm-6 col-lg-3 */}
        <div className="col-sm-6 col-lg-3">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-rotate-left" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Free Returns</h3>{/* End .icon-box-title */}
              <p>Within 30 days</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
        </div>{/* End .col-sm-6 col-lg-3 */}
        <div className="col-sm-6 col-lg-3">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-info-circle" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">Get 20% Off 1 Item</h3>{/* End .icon-box-title */}
              <p>When you sign up</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
        </div>{/* End .col-sm-6 col-lg-3 */}
        <div className="col-sm-6 col-lg-3">
          <div className="icon-box icon-box-side">
            <span className="icon-box-icon">
              <i className="icon-life-ring" />
            </span>
            <div className="icon-box-content">
              <h3 className="icon-box-title">We Support</h3>{/* End .icon-box-title */}
              <p>24/7 amazing services</p>
            </div>{/* End .icon-box-content */}
          </div>{/* End .icon-box */}
        </div>{/* End .col-sm-6 col-lg-3 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .icon-boxes-container */}
  <div className="bg-light pt-3 pb-5 mb-5">
    <div className="container">
      <ul className="nav nav-pills nav-big nav-border-anim justify-content-center mb-5" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="products-trending-link" data-toggle="tab" href="#products-trending-tab" role="tab" aria-controls="products-trending-tab" aria-selected="true">Now Trending</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="products-new-link" data-toggle="tab" href="#products-new-tab" role="tab" aria-controls="products-new-tab" aria-selected="false">New Releases</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="products-best-link" data-toggle="tab" href="#products-best-tab" role="tab" aria-controls="products-best-tab" aria-selected="false">Best-Rated</a>
        </li>
      </ul>
      <div className="tab-content tab-content-carousel">
        <div className="tab-pane p-0 fade show active" id="products-trending-tab" role="tabpanel" aria-labelledby="products-trending-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5,
                          &quot;nav&quot;: true
                      }
                  }
              }">
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-1.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Call of Duty <br />WWII - Gold Edition</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$24.00</span>
                  <span className="old-price">Was $59.99</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-2.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">World War Z</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-top">Top</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-3.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Borderlands: <br />The Handsome Collection</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $59.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-4.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Witcher 3: Wild Hunt</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-5.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">GTA Online: Criminal Enterprise Starter Pack</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$19.49</span>
                  <span className="old-price">Was $24.49</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-6.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Tom Clancy’s <br />Ghost Recon Wildlands</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $49.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
        <div className="tab-pane p-0 fade" id="products-new-tab" role="tabpanel" aria-labelledby="products-new-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5,
                          &quot;nav&quot;: true
                      }
                  }
              }">
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-6.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Tom Clancy’s <br />Ghost Recon Wildlands</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $49.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-5.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">GTA Online: Criminal Enterprise Starter Pack</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$19.49</span>
                  <span className="old-price">Was $24.49</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-2.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">World War Z</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-1.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Call of Duty <br />WWII - Gold Edition</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$24.00</span>
                  <span className="old-price">Was $59.99</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-top">Top</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-3.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Borderlands: <br />The Handsome Collection</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $59.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-4.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Witcher 3: Wild Hunt</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
        <div className="tab-pane p-0 fade" id="products-best-tab" role="tabpanel" aria-labelledby="products-best-link">
          <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:5,
                          &quot;nav&quot;: true
                      }
                  }
              }">
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-top">Top</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-3.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Borderlands: <br />The Handsome Collection</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $59.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-2.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">World War Z</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-4.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Witcher 3: Wild Hunt</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $39.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <span className="product-label label-sale">Sale</span>
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-5.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Action &amp; adventure</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">GTA Online: Criminal Enterprise Starter Pack</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$19.49</span>
                  <span className="old-price">Was $24.49</span>
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-19/products/product-6.jpg" alt="Product image" className="product-image" />
                </a>
                <div className="product-action-vertical">
                  <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                </div>{/* End .product-action-vertical */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  <a href="#">Shooter</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Tom Clancy’s <br />Ghost Recon Wildlands</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $49.99
                </div>{/* End .product-price */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* .End .tab-pane */}
      </div>{/* End .tab-content */}
    </div>{/* End .container */}
  </div>{/* End .bg-light pt-4 pb-4 */}
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-sm-6 col-md-4">
        <div className="banner banner-overlay banner-sm banner-ad content-left align-center">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-6.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-subtitle">Weekend Offer</h4>
            <img className="banner-title-img" src="asset/images/demos/demo-19/banners/banner-6-title.png" alt="Banner-6" />
            <h4 className="banner-price"><span className="off" style={{fontWeight: 600}}>Save <span className="price">$19.99</span></span></h4>
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-md-4 */}
      <div className="col-sm-6 col-md-4">
        <div className="banner banner-overlay banner-sm banner-ad content-left align-center">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-7.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-subtitle" style={{letterSpacing: '0.1em'}}>Amazing Deal on an</h4>
            <h2 className="banner-title mb-0" style={{fontSize: '3rem'}}>XBOX ONE</h2>
            <h4 className="banner-price"><span className="off" style={{fontWeight: 600}}>Save $50</span></h4>
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-md-4 */}
      <div className="col-sm-6 col-md-4">
        <div className="banner banner-overlay banner-sm banner-ad content-left align-center">
          <a href="#">
            <img src="asset/images/demos/demo-19/banners/banner-8.jpg" alt="Banner" />
          </a>
          <div className="banner-content">
            <h4 className="banner-price text-white mb-1">Save $29.00</h4>
            <img className="banner-title-img mb-2" src="asset/images/demos/demo-19/banners/banner-8-title.png" alt="Banner-8" />
            <a href="#" className="banner-link">Buy Now<i className="icon-long-arrow-right" /></a>
          </div>
        </div>{/* End .banner */}
      </div>{/* End .col-md-4 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="container">
    <hr className="mt-0 mb-4" />
  </div>{/* End .container */}
  <div className="container">
    <div className="heading heading-flex mb-2 mb-lg-3">
      <div className="heading-left">
        <h2 className="title mb-0">Games Coming Soon</h2>{/* End .title */}
      </div>{/* End .heading-left */}
      <div className="heading-right">
        <a href="category.html" className="title-link">View more products <i className="icon-long-arrow-right" /></a>
      </div>{/* End .heading-right */}
    </div>{/* End .heading */}
    <div className="games-soon">
      <div className="row">
        <div className="col-lg-7">
          <div className="products">
            <div className="row">
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-6.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Shooter</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">Tom Clancy’s <br />Ghost Recon Wildlands</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $49.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-7.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Sport</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">NBA 2K19 450,000 VC</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $74.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-8.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Shooter</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">STAR WARS Battlefront II</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $24.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-9.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Shooter</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">Call of Duty: Black Ops 4 Spectre Rising Edition</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $39.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-10.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>Pre-order Now</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Role playing</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">Diablo III: <br />Eternal Collection</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $19.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
              <div className="col-6 col-md-4">
                <div className="product">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/demos/demo-19/products/product-11.jpg" alt="Product image" className="product-image" />
                    </a>
                    <div className="product-action-vertical">
                      <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
                    </div>{/* End .product-action-vertical */}
                    <div className="product-action">
                      <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    </div>{/* End .product-action */}
                  </figure>{/* End .product-media */}
                  <div className="product-body">
                    <div className="product-cat">
                      <a href="#">Role playing</a>
                    </div>{/* End .product-cat */}
                    <h3 className="product-title"><a href="product.html">Tom Clancy's <br />The Division 2</a></h3>{/* End .product-title */}
                    <div className="product-price">
                      $24.99
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product */}
              </div>{/* End .col-sm-6 col-md-4 */}
            </div>{/* End .row */}
          </div>{/* End .products */}
        </div>{/* End .col-lg-7 */}
        <div className="col-lg-5 order-lg-first">
          <div className="games-banners-slider owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 0,
                  &quot;loop&quot;: false,
                  &quot;items&quot;:1
              }">
            <div className="banner banner-overlay product-banner">
              <a href="#">
                <img src="asset/images/demos/demo-19/banners/banner-9.jpg" alt="Banner" />
              </a>
              <div className="banner-content align-items-center center">
                <img className="banner-title-img mb-1" src="asset/images/demos/demo-19/banners/banner-9-title.png" alt="Banner-9" />
                <h4 className="banner-price mb-2" style={{fontWeight: 600}}>$29.99</h4>
                <a href="#" className="banner-link size-lg">Pre-Order Now<i className="icon-long-arrow-right" /></a>
              </div>
            </div>{/* End .banner */}
            <div className="banner banner-overlay product-banner">
              <a href="#">
                <img src="asset/images/demos/demo-19/banners/banner-10.jpg" alt="Banner" />
              </a>
              <div className="banner-content align-items-center">
                <h4 className="banner-subtitle" style={{letterSpacing: '0.1em'}}>Out 14 May 2019</h4>
                <img className="banner-title-img mb-1" src="asset/images/demos/demo-19/banners/banner-10-title.png" alt="Banner-10" />
                <a href="#" className="banner-link size-lg">Pre-Order Now<i className="icon-long-arrow-right" /></a>
              </div>
            </div>{/* End .banner */}
          </div>{/* End .owl-carousel */}
        </div>{/* End .col-lg-5 */}
      </div>{/* End .row */}
    </div>{/* End .games-soon */}
  </div>{/* End .container */}
  <div className="mb-3" />{/* End .mb-3 */}
  <div className="container">
    <div className="cta cta-horizontal cta-horizontal-box bg-image mb-4" style={{backgroundImage: 'url(asset/images/demos/demo-19/bg-2.jpg)'}}>
      <div className="row align-items-center">
        <div className="col-lg-5">
          <h3 className="cta-title text-primary">Join Our Newsletter</h3>{/* End .cta-title */}
          <p className="cta-desc text-light">Subcribe to get information about products and coupons</p>{/* End .cta-desc */}
        </div>{/* End .col-lg-5 */}
        <div className="col-lg-7 d-flex justify-content-lg-end">
          <form action="#">
            <div className="input-group">
              <input type="email" className="form-control form-control-white" placeholder="Enter your Email Address" aria-label="Email Adress" required />
              <div className="input-group-append">
                <button className="btn btn-primary-white btn-rounded" type="submit"><span>Subscribe</span><i className="icon-long-arrow-right" /></button>
              </div>{/* .End .input-group-append */}
            </div>{/* .End .input-group */}
          </form>
        </div>{/* End .col-lg-8 */}
      </div>{/* End .row */}
    </div>{/* End .cta */}
  </div>{/* End .container */}
  <div className="container">
    <div className="heading heading-flex mb-2">
      <div className="heading-left">
        <h2 className="title mb-5">Consoles &amp; Accessories</h2>{/* End .title */}
      </div>{/* End .heading-left */}
      <div className="heading-right">
        <a href="category.html" className="title-link">View more products <i className="icon-long-arrow-right" /></a>
      </div>{/* End .heading-right */}
    </div>{/* End .heading */}
    <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
      &quot;nav&quot;: false, 
      &quot;dots&quot;: true,
      &quot;margin&quot;: 20,
      &quot;loop&quot;: false,
      &quot;responsive&quot;: {
          &quot;0&quot;: {
              &quot;items&quot;:2
          },
          &quot;480&quot;: {
              &quot;items&quot;:2
          },
          &quot;768&quot;: {
              &quot;items&quot;:3
          },
          &quot;992&quot;: {
              &quot;items&quot;:4
          },
          &quot;1200&quot;: {
              &quot;items&quot;:5,
              &quot;nav&quot;: true
          }
      }
  }">
      <div className="product">
        <figure className="product-media">
          <span className="product-label label-new">New</span>
          <a href="product.html">
            <img src="asset/images/demos/demo-19/products/product-12.jpg" alt="Product image" className="product-image" />
          </a>
          <div className="product-action-vertical">
            <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
          </div>{/* End .product-action-vertical */}
          <div className="product-action">
            <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
          </div>{/* End .product-action */}
        </figure>{/* End .product-media */}
        <div className="product-body">
          <h3 className="product-title"><a href="product.html">Microsoft - Xbox Elite Wireless Controller</a></h3>{/* End .product-title */}
          <div className="product-price">
            $149.99
          </div>{/* End .product-price */}
        </div>{/* End .product-body */}
      </div>{/* End .product */}
      <div className="product">
        <figure className="product-media">
          <span className="product-label label-top">Top</span>
          <a href="product.html">
            <img src="asset/images/demos/demo-19/products/product-13.jpg" alt="Product image" className="product-image" />
          </a>
          <div className="product-action-vertical">
            <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
          </div>{/* End .product-action-vertical */}
          <div className="product-action">
            <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
          </div>{/* End .product-action */}
        </figure>{/* End .product-media */}
        <div className="product-body">
          <h3 className="product-title"><a href="product.html">Sony - PlayStation 4 1TB Console - Black</a></h3>{/* End .product-title */}
          <div className="product-price">
            $299.99
          </div>{/* End .product-price */}
        </div>{/* End .product-body */}
      </div>{/* End .product */}
      <div className="product">
        <figure className="product-media">
          <a href="product.html">
            <img src="asset/images/demos/demo-19/products/product-14.jpg" alt="Product image" className="product-image" />
          </a>
          <div className="product-action-vertical">
            <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
          </div>{/* End .product-action-vertical */}
          <div className="product-action">
            <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
          </div>{/* End .product-action */}
        </figure>{/* End .product-media */}
        <div className="product-body">
          <h3 className="product-title"><a href="product.html">Nintendo - Switch 32GB Console</a></h3>{/* End .product-title */}
          <div className="product-price">
            $149.99
          </div>{/* End .product-price */}
        </div>{/* End .product-body */}
      </div>{/* End .product */}
      <div className="product">
        <figure className="product-media">
          <span className="product-label label-top">Top</span>
          <a href="product.html">
            <img src="asset/images/demos/demo-19/products/product-15.jpg" alt="Product image" className="product-image" />
          </a>
          <div className="product-action-vertical">
            <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
          </div>{/* End .product-action-vertical */}
          <div className="product-action">
            <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
          </div>{/* End .product-action */}
        </figure>{/* End .product-media */}
        <div className="product-body">
          <h3 className="product-title"><a href="product.html">HyperX - Cloud Alpha Wired Stereo Gaming Headset</a></h3>{/* End .product-title */}
          <div className="product-price">
            $99.99
          </div>{/* End .product-price */}
        </div>{/* End .product-body */}
      </div>{/* End .product */}
      <div className="product">
        <figure className="product-media">
          <a href="product.html">
            <img src="asset/images/demos/demo-19/products/product-16.jpg" alt="Product image" className="product-image" />
          </a>
          <div className="product-action-vertical">
            <a href="#" className="btn-product-icon btn-wishlist" title="Add to Wishlist"><span>add to wishlist</span></a>
          </div>{/* End .product-action-vertical */}
          <div className="product-action">
            <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
          </div>{/* End .product-action */}
        </figure>{/* End .product-media */}
        <div className="product-body">
          <h3 className="product-title"><a href="product.html">Logitech - G502 HERO Wired Optical Gaming Mouse Pack</a></h3>{/* End .product-title */}
          <div className="product-price">
            $59.99
          </div>{/* End .product-price */}
        </div>{/* End .product-body */}
      </div>{/* End .product */}
    </div>{/* End .owl-carousel */}
    <div className="mb-5" />{/* End .mb-4 */}
  </div>{/* End .container */}
  <div className="blog-posts bg-light pt-4 pb-5">
    <div className="container">
      <div className="heading heading-flex mb-2">
        <div className="heading-left">
          <h2 className="title mb-0">From Our Blog</h2>{/* End .title */}
        </div>{/* End .heading-left */}
        <div className="heading-right">
          <a href="blog.html" className="title-link">View more articles <i className="icon-long-arrow-right" /></a>
        </div>{/* End .heading-right */}
      </div>{/* End .heading */}
      <div className="owl-carousel owl-simple carousel-equal-height" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;600&quot;: {
                  &quot;items&quot;:2
              },
              &quot;992&quot;: {
                  &quot;items&quot;:3
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:4,
                  &quot;nav&quot;: true
              }
          }
      }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-19/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Morbi in sem quis dui placerat mauris sit ornare.</a>
            </h3>{/* End .entry-title */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-19/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aliquam porttitor mauris sit ametorci.</a>
            </h3>{/* End .entry-title */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-19/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Cras ornare tristique elit.</a>
            </h3>{/* End .entry-title */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-19/blog/post-4.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Donec consectetuer ligula vulputate sem cursus.</a>
            </h3>{/* End .entry-title */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-19/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Morbi in sem quis dui placerat mauris sit ornare.</a>
            </h3>{/* End .entry-title */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .blog-posts */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Index19